import React from 'react';
import PropTypes from 'prop-types';

const HelpPageTitle = ({ sMatchType }) => {
  const ParentMessage = (
    <div className='help__instructions'>
      <p>
        But first, are you a new parent that can&apos;t find their name during
        search?
      </p>
      <p>
        If so, it&apos;s likely because families do not show up in Wake Network
        until their student&apos;s admissions deposit has been received and
        processed; depending on how you paid your deposit, it could take a week
        or two to be received and processed.
      </p>
      <p>
        Please try again in a week or two and if your name still isn&apos;t
        there, let us know and we&apos;ll take care of it!
      </p>
    </div>
  );

  return (
    <>
      <h2>We&apos;re here to help!</h2>
      {sMatchType === 'parent' ? (
        ParentMessage
      ) : (
        <p className='help__instructions'>
          Tell us more about the problem. We&apos;ll look into it and reach out
          via email soon.
        </p>
      )}
    </>
  );
};

HelpPageTitle.propTypes = {
  sMatchType: PropTypes.string,
};

HelpPageTitle.defaultProps = {
  sMatchType: '',
};

export default HelpPageTitle;
